import { Field, useField, useFormikContext } from 'formik'

import Select from 'components/Select'
import TextBox from 'components/TextBox'

const GeneralDetails = ({ id, showValidationErrors }) => {
  const { values, setFieldValue } = useFormikContext()
  const [field, fieldMeta] = useField('inventoryState')

  const availabilityAutocompleteOptions = [
    { name: 'Available', uuid: 'available', value: 'available' },
    {
      name: 'Low On Inventory',
      uuid: 'low_on_inventory',
      value: 'low_on_inventory',
    },
    {
      name: 'Unavailable',
      uuid: 'unavailable',
      value: 'unavailable',
    },
  ]

  const handleAvailabilityChange = (value) => {
    setFieldValue('inventoryState', value)
  }

  return (
    <div className="item-details" id={id}>
      <div className="text-field">
        <Field
          component={TextBox}
          label="Name"
          name="name"
          showValidationErrors={showValidationErrors}
        />
      </div>
      <div className="text-field">
        <Field
          component={TextBox}
          label="Display Name"
          name="displayName"
          showValidationErrors={showValidationErrors}
        />
      </div>
      <div className="text-field">
        <Field
          component={TextBox}
          label="Description"
          name="description"
        />
      </div>
      <div className="text-field">
        <Field
          component={TextBox}
          label="Inventory Classification"
          name="customerAttributes.inventoryClassification"
        />
      </div>
      <div className="text-field">
        <Field
          component={TextBox}
          label="SKU"
          name="productSku"
          showValidationErrors={showValidationErrors}
        />
      </div>
      <div className="text-field">
        <Field component={TextBox} label="Barcode" name="barcode" />
      </div>
      <div className="text-field">
        <Field
          component={Select}
          defaultValue={values?.inventoryState}
          label="Availability"
          handleChange={handleAvailabilityChange}
          options={availabilityAutocompleteOptions}
          showValidationErrors={showValidationErrors}
          error={fieldMeta.error}
          name="inventoryState"
          dataCy="inventoryState-select"
        />
      </div>
    </div>
  )
}

export default GeneralDetails
